import { FREE_CHAT } from 'components/dashboard/constants'
import { locales } from 'components/dashboard/data/locales'
import moment from 'moment'

const SUBSCRIPTION_TYPE = 'subscription'
const SERVICE_TYPE = 'service'

const bundlePriority = {
  'time': 0,
  'data': 1,
}

export const formatCurrency = (currencyCode = '', formatMessage) => {
  switch (currencyCode.toUpperCase()) {
    case 'EUR':
      return formatMessage({ id: 'Common.EUR' })
    case 'CNY':
      return formatMessage({ id: 'Common.CNY' })
    default:
      return currencyCode
  }
}

export const momentLocale = locale => {
  switch (locale) {
    case 'cn':
      return 'zh-cn'
    case 'jp':
      return 'ja'
    default:
      return locale
  }
}

export const findActiveBundle = allBundles => {
  const bundles = allBundles.filter(el => !isSubscription(el) && !isService(el))

  if (!bundles) {
    return null
  }

  // attach packages activate when customer is in coverage zone
  const nonAttachBundles = bundles.filter(el => el.activation !== 'attach')

  switch (nonAttachBundles.length) {
    case 0:
      // Если нет нормальных пакетов, которые не ебанутые (attach), пытаемся найти Free Chat
      return bundles.find(el => el.supplementary)
    case 1:
      // Если нормальный пакет всего один, показываем его
      return nonAttachBundles[0]
    default:
      // Если их несколько, показываем
      // первый из отсортированных по bundlePriority (который НЕ Free Chat)
      // или хоть какой-нибудь вообще

      const nonAttachBundlesNotFreechat = nonAttachBundles.filter(el => el.name !== FREE_CHAT)
      const nonAttachBundlesNotFreechatSorted = nonAttachBundlesNotFreechat.sort((a, b) => bundlePriority[a.bundle_type] - bundlePriority[b.bundle_type])
      return nonAttachBundlesNotFreechatSorted[0] || nonAttachBundles[0]
  }
}

export const isComboBundle = usageInfo => {
  const { traffic_used_map, traffic_remain_map } = usageInfo
  return traffic_used_map ? (traffic_used_map.eu && traffic_used_map.global) : false
}

// returns the byte length of an utf8 string
export const byteLength = str => {
  var s = str.length

  for (var i=str.length-1; i>=0; i--) {
    var code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s+=2
    if (code >= 0xDC00 && code <= 0xDFFF) i-- //trail surrogate
  }

  return s
}

export const checkInternet = (simcards, onnetIccid, balance) => {
  // it means offnet connection -> does not fuck us at all
  if (!onnetIccid) {
    return true
  }

  if (simcards.length === 0) {
    return false
  }

  const activeSimcard = simcards.find(s => s.icc === onnetIccid)
  let bundles

  // just in case
  if (activeSimcard) {
    bundles = activeSimcard.bundles_active
  } else {
    return false
  }

  // no any active package -> no internet
  if (bundles.length === 0) {
    return false
  }

  // search for any package with internet quota
  // but not zero-rated (i.e. FREE CHAT)
  const normalBundles = bundles.filter(b => !b.supplementary)
  switch (normalBundles.length) {
    case 0:
      return false
    case 1:
      const payAsYouGo = normalBundles.some(b => b.price < 1)
      return payAsYouGo && balance > 1
    default:
      return true
  }
}

// byte length 2
// lengthInUtf8Bytes(str) {
//   // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
//   var m = encodeURIComponent(str).match(/%[89ABab]/g);
//   return str.length + (m ? m.length : 0);
// }

// byte length 3 IE requires polyfill text-encoding
// (new TextEncoder('utf-8').encode(e.target.value)).length)

export const truncateIcc = icc => String(icc).slice(-7).slice(0, -1)
export const cardName = simcard => `${simcard.description} (#${truncateIcc(simcard.icc)})`

export const getIntlLocale = locale => {
  if (locales[locale]) {
    return locales[locale].intlLocale
  }

  return locales[0].intlLocale
}

// export const isIdentityWanted = (user, date) => (
//   checkUserPhotoStatus(user, date, ['loaded', 'accepted'])
// )

export const isIdentityUnverified = (user, date) => (
  checkUserPhotoStatus(user, date, ['accepted'])
)

const checkUserPhotoStatus = (user, date, statuses) => {
  const dateX = moment(date, 'DD.MM.YYYY')
  const createdAt = moment(user.created_at)

  if (createdAt && (createdAt.diff(dateX) > 0)) {
    return !statuses.includes(user.photo_status)
  }

  return false
}

export const base64toBlob = (base64Data, type) => {
  const contentType = type || ''
  const sliceSize = 1024
  const byteCharacters = atob(base64Data)
  const bytesLength = byteCharacters.length
  const slicesCount = Math.ceil(bytesLength / sliceSize)
  const byteArrays = new Array(slicesCount)

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize
    const end = Math.min(begin + sliceSize, bytesLength)

    const bytes = new Array(end - begin)
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0)
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes)
  }
  return new Blob(byteArrays, { type: contentType })
}

export const isSubscription = bundle => {
  return bundle.bundle_type === SUBSCRIPTION_TYPE
}

export const isService = bundle => {
  return bundle.bundle_type === SERVICE_TYPE
}

// Внимание! Здесь не все возможные ключи, проверь!
export const fieldNameToTranslateKey = {
  first_name: 'FirstName',
  last_name: 'LastName',
  city: 'City',
  street_number: 'StreetNumber',
  state: 'Region',
  zipcode: 'ZipCode',
  floor_unit: 'FloorUnit',
  street: 'Street',
  street_unit: 'StreetUnit',
}

export const shoudShowAppleBanner = props => props?.resources?.features?.appearance?.apple_app_banner === 'mtx'

export const shoudShowGoogleBanner = props => props?.resources?.features?.appearance?.google_app_banner === 'mtx'



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/util.js